export default {
    cz: {
        chooseFile: 'Vyberte soubor',
        chooseFiles: 'Vyberte soubory',
        limits: {
            maxFileSize: (fileSize: string) => `Maximální velikost jednoho souboru je ${fileSize}.`,
            maxFiles: (maxFiles: number) => `Maximální počet souborů je ${maxFiles}.`,
            maxTotalSize: (maxTotalSize: string) => `Maximální celková velikost souborů je ${maxTotalSize}.`,
            accept: (accept: string) => `Povolené typy souborů jsou ${accept}.`,
        },
    },
    sk: {
        chooseFile: 'Vyberte súbor',
        chooseFiles: 'Vyberte súbory',
        limits: {
            maxFileSize: (fileSize: string) => `Maximálna veľkosť jedného súboru je ${fileSize}.`,
            maxFiles: (maxFiles: number) => `Maximálny počet súborov je ${maxFiles}.`,
            maxTotalSize: (maxTotalSize: string) => `Maximálna celková veľkosť súborov je ${maxTotalSize}.`,
            accept: (accept: string) => `Povolené typy súborov sú ${accept}.`,
        },
    },
}
